import { CircularProgress, List, Typography } from "@mui/material/";
import { useContext, useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import DataContext from "../../../context/DataContext";
import { useQueryParams } from "../../../hooks/useQueryParams";
import ClientListItemProCli from "../../global/ClientListItemProCli";
import HNSColors from "../../ui library/HNSColors";
import Pagination from "../Common/Pagination";
import DrawerFilterChips from "../drawer-filters/components/DrawerFilterChips";
import DrawerFilters from "../drawer-filters/components/DrawerFilters";
import DrawerFiltersList from "../drawer-filters/components/DrawerFiltersList";
import FilterSearch from "../drawer-filters/components/FilterSearch";
import { useDrawerFilters } from "../drawer-filters/hooks/useDrawerFilters";

import { FilterListConfig } from "./utils/FilterListConfig";

const ITEMS_PER_PAGE = 25;

export default function ProviderClientSearch() {
  const { data, count } = useLoaderData();
  const { userType } = useContext(DataContext);
  const { updateFilter, filters } = useQueryParams();
  const offset = filters.get("offset") ?? ITEMS_PER_PAGE;
  const { filterState, activeFilters } = useDrawerFilters(FilterListConfig, {
    replaceNavigation: true,
  });
  const [loading, setLoading] = useState(true);

  const columnClasses = userType === "Client Case Management" ? "md:w-1/5 w-1/3" : "md:w-1/4 w-1/3";

  useEffect(() => {
    setLoading(true);

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [data]);

  return (
    <div className="relative flex w-full flex-wrap overflow-hidden rounded-md bg-white p-4 shadow-[3px_3px_10px_0px_rgba(188,209,255)]">
      <div className="w-full mt-2 mb-8">
        <Typography variant="h5" fontWeight={600} style={{ color: HNSColors.primary[400] }}>
          Provider Client Search
        </Typography>
      </div>
      <div className="flex w-full gap-2">
        <FilterSearch />
        <DrawerFilters
          title="Filters"
          triggerId="prov-client-search-filters-button"
          closeButtonId="prov-client-search-filters-close-button"
        >
          <DrawerFiltersList filterState={filterState} />
        </DrawerFilters>
      </div>
      <div className="flex w-full mt-4">
        <DrawerFilterChips activeFilters={activeFilters} />
      </div>

      <div className="w-full">
        {/* Table */}
        <div className="h-full overflow-hidden">
          <div className="flex justify-between my-2 mb-4">
            <p className="text-sm">
              Showing: {data.length} / {count}
            </p>
          </div>{" "}
          <div className="flex px-0 py-2 text-center border-b border-1 border-gray justify-evenly sm:px-4">
            <div className={`w-1/3 font-bold md:w-[20%]`}>
              <h2 className="hidden md:block">CLIENT NAME</h2>
              <h2 className="md:hidden">NAME</h2>
            </div>
            <div className={`hidden font-bold md:block md:w-[15%]`}>
              <h2>CREATED</h2>
            </div>
            <div className={`${columnClasses} font-bold`}>
              <h2>STATUS</h2>
            </div>
            <div className={`w-1/3 font-bold md:w-[25%]`}>
              <h2>PROVIDER</h2>
            </div>
            {userType === "Client Case Management" ? (
              <div className={`${columnClasses} hidden font-bold md:block`}>
                <h2>LAW FIRM</h2>
              </div>
            ) : (
              ""
            )}
          </div>
          <List className="grid max-h-[80vh] overflow-y-auto">
            {loading ? (
              <div className="flex justify-center my-24">
                <CircularProgress color="secondary" />
              </div>
            ) : (
              <>
                {(data || []).map((client, index) => (
                  <ClientListItemProCli
                    key={index}
                    client={client}
                    index={index}
                    currentPage={offset / ITEMS_PER_PAGE}
                  />
                ))}
              </>
            )}
            <div className="mt-4">
              <Pagination
                filters={filters}
                id="prov-client-search-pagination"
                limit={ITEMS_PER_PAGE}
                updateFilter={updateFilter}
                totalCount={count}
              />
            </div>
          </List>
        </div>
      </div>
    </div>
  );
}
